import React from 'react';
import { Link } from 'react-router-dom';
import textService from '../../services/text';
import logo_footer from '../../assets/logo.png';
import logo_instagram from '../../assets/in.svg';
import OptimizedImage from '../optimizedImage/optimizedImage';

const Footer = () => {
  return (
    <footer className="patio-purpura-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            <OptimizedImage 
              src={logo_footer}
              alt="Patio Púrpura Logo" 
              className="patio-purpura-footer-logo" 
              sizes="200px"
            />
            <p className="footer-description">
              Pan artesanal hecho en casa con paciencia y amor. 
              Porque todo lo bueno toma su tiempo.
            </p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Contacto</h3>
          <div className="footer-contact">
            <a 
              className="footer-email"
              href={`mailto:${textService.getEmail()}`}
            >
              📧 {textService.getEmail()}
            </a>
            <a 
              className="footer-phone"
              href="tel:+50688644774"
            >
              📱 +506 8864-4774
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Horarios</h3>
          <div className="footer-hours">
            <p><strong>Pedidos:</strong> Antes del martes</p>
            <p><strong>Entrega:</strong> Jueves - Viernes</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Síguenos</h3>
          <div className="footer-social">
            <a
              className="patio-purpura-instagram"
              href="https://www.instagram.com/patiopurpura"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Síguenos en Instagram"
            >
              <img 
                alt="Patio Púrpura Instagram" 
                className="patio-purpura-instragram" 
                src={logo_instagram}
                title="Patio Púrpura Instagram" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">
            © {new Date().getFullYear()} Patio Púrpura. Todos los derechos reservados.
          </p>
          <div className="footer-links">
            <Link to="/" className="footer-link">Inicio</Link>
            <Link to="/contactenos" className="footer-link">Contacto</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
